export default "__VITE_PUBLIC_ASSET__dc11c993__"